<template>
  <generic-modal :title="$t('debt level case')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("promissory note number") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.promissory_note_number"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <generic-uploader
            ref="generic_uploader"
            :idle_label="$t('drop sirc pdf here')"
            endpoint_url="/debt-level/pdf"
            :allow_multiple="false"
            @error="error_uploading"
            @success="success_uploading"
          />
        </div>
      </div>
      <!-- <div class="field">
        <label class="label">{{ $t("name") }}</label>
        <div class="control">
          <input class="input" type="text" v-model="meta.name" />
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("dpi") }}</label>
        <div class="control">
          <input class="input" type="text" v-model="meta.dpi" />
        </div>
      </div> -->
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";

export default {
  name: "DebtLevelModal",
  components: { GenericModal, GenericUploader },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.promissory_note_number || !v.meta.pdf_file;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/debt-level", { uuid: uuid })
        .then((element) => {
          v.meta = element;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      v.$root.loader(true);
      if (!v.meta.uuid)
        put("/debt-level", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => v.$root.loader(false));
      else
        post("/debt-level", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => v.$root.loader(false));
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        promissory_note_number: "",
        settings: {},
      };
      v.$refs.generic_uploader.clear();
      v.error = "";
      // v.uuid = "";
    },
    error_uploading(error) {
      console.error(error);
      error_message(error);
    },
    success_uploading(response) {
      let v = this;
      // v.$refs.generic_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      let data = {
        file_id: rspnse.file.file_id,
        final_name: rspnse.final_name,
        meta: rspnse.file.settings,
        original_name: rspnse.file.name,
      };

      v.meta.pdf_file = data;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
